import ArticleAdvancedSearch from './ArticleAdvancedSearch';
import ArticleDetail from './ArticleDetail';
import ArticleList from './ArticleList';
import ArticleTop from './ArticleTop';

const ItemTypeArticle = {
    Top: ArticleTop,
    List: ArticleList,
    Detail: ArticleDetail,
    AdvancedSearch: ArticleAdvancedSearch,
};

export default ItemTypeArticle;
